// src/SimplifiedDeviceState.js
import React from "react";
import "./SimplifiedDeviceState.css";

// Helper rendering functions (reused from DeviceState.js)
const renderLockStateValue = (value) => {
  if (!value) return String(value);
  const stringValue = String(value);
  const upperCaseValue = stringValue.toUpperCase();

  // Handle frozen lock states
  if (upperCaseValue === "FROZEN_SECURED") {
    return (
      <span className="simplified-state-frozen-secured">FROZEN_SECURED</span>
    );
  }
  if (upperCaseValue === "FROZEN_PASSAGE") {
    return (
      <span className="simplified-state-frozen-passage">FROZEN_PASSAGE</span>
    );
  }

  // Handle normal lock states
  const lowerCaseValue = stringValue.toLowerCase();
  if (lowerCaseValue === "passage") {
    return <span className="simplified-state-passage">{value}</span>;
  }
  if (lowerCaseValue === "secured") {
    return <span className="simplified-state-secured">{value}</span>;
  }
  return String(value);
};

const renderDoorPosition = (value) => {
  if (!value) return String(value);
  const upperCaseValue = String(value).toUpperCase();

  if (upperCaseValue === "OPEN") {
    return <span className="simplified-door-position-open">OPEN</span>;
  }
  if (upperCaseValue === "SHUT") {
    return <span className="simplified-door-position-shut">SHUT</span>;
  }
  return String(value);
};

const renderBatteryLevel = (levelText) => {
  if (!levelText) return String(levelText);
  const upperCaseLevel = String(levelText).toUpperCase();

  let className = "";
  switch (upperCaseLevel) {
    case "NORMAL":
      className = "simplified-battery-normal";
      break;
    case "LOW":
      className = "simplified-battery-low";
      break;
    case "CRITICAL":
      className = "simplified-battery-critical";
      break;
    default:
      break;
  }
  return <span className={className}>{levelText}</span>;
};

const renderDeadboltState = (value) => {
  if (!value) return String(value);
  const stringValue = String(value);
  const upperCaseValue = stringValue.toUpperCase();

  if (upperCaseValue === "SECURED") {
    return <span className="simplified-deadbolt-secured">Secured</span>;
  }
  if (upperCaseValue === "PASSAGE") {
    return <span className="simplified-deadbolt-passage">Passage</span>;
  }
  if (upperCaseValue === "UNKNOWN") {
    return <span className="simplified-deadbolt-other">Unknown</span>;
  }
  return <span className="simplified-deadbolt-other">{stringValue}</span>;
};

const renderConnectivityStatus = (statusText) => {
  if (!statusText) return String(statusText);
  const lowerCaseStatus = String(statusText).toUpperCase();
  if (lowerCaseStatus === "ONLINE") {
    return <span className="simplified-status-online">ONLINE</span>;
  }
  if (lowerCaseStatus === "OFFLINE") {
    return <span className="simplified-status-offline">OFFLINE</span>;
  }
  return String(statusText);
};

const renderLockdownState = (value) => {
  if (!value) return String(value);
  const stringValue = String(value);

  if (stringValue === "Lockdown On") {
    return <span className="simplified-state-lockdown-on">Lockdown On</span>;
  }
  if (stringValue === "Lockdown Off") {
    return <span className="simplified-state-lockdown-off">Lockdown Off</span>;
  }
  return String(value);
};

const SimplifiedDeviceState = ({
  deviceState,
  connectivityStatusUpdateTime,
}) => {
  if (!deviceState) {
    return null;
  }

  const lockState = deviceState.lockState;
  const doorPosition = deviceState.doorPosition;
  const deadboltState = deviceState.deadboltState;
  const connectivityStatus = deviceState.connectivityStatus;
  const batteryLevel = deviceState.batteryLevel;
  const lockdownState = deviceState.lockdownState;

  return (
    <div className="simplified-device-state-container">
      <h2>Device State</h2>
      <div className="simplified-state-grid">
        <div className="simplified-state-item">
          <span className="simplified-state-label">Lock State:</span>
          <span className="simplified-state-value">
            {lockState !== undefined && lockState !== null
              ? renderLockStateValue(lockState)
              : "Not Yet Sampled"}
          </span>
        </div>
        <div className="simplified-state-item">
          <span className="simplified-state-label">Door State:</span>
          <span className="simplified-state-value">
            {doorPosition !== undefined && doorPosition !== null
              ? renderDoorPosition(doorPosition)
              : "Not Yet Sampled"}
          </span>
        </div>
        <div className="simplified-state-item">
          <span className="simplified-state-label">Deadbolt State:</span>
          <span className="simplified-state-value">
            {deadboltState !== undefined && deadboltState !== null
              ? renderDeadboltState(deadboltState)
              : "Not Yet Sampled"}
          </span>
        </div>
        <div className="simplified-state-item">
          <span className="simplified-state-label">Wi-Fi Status:</span>
          <span className="simplified-state-value">
            {connectivityStatus !== undefined && connectivityStatus !== null
              ? renderConnectivityStatus(connectivityStatus)
              : "Not Yet Sampled"}
          </span>
        </div>
        <div className="simplified-state-item">
          <span className="simplified-state-label">Battery Level:</span>
          <span className="simplified-state-value">
            {batteryLevel !== undefined && batteryLevel !== null
              ? renderBatteryLevel(batteryLevel)
              : "Not Yet Sampled"}
          </span>
        </div>
        <div className="simplified-state-item">
          <span className="simplified-state-label">Lockdown Status:</span>
          <span className="simplified-state-value">
            {lockdownState !== undefined && lockdownState !== null
              ? renderLockdownState(lockdownState)
              : "Not Yet Sampled"}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SimplifiedDeviceState;
